import React, { Component } from 'react'
import style from './style.css'

export default class Textarea extends Component {
    render() {
        return (
            <div className={style.boxField}>
                <textarea
                    className={`${style.text} ${style.textarea} ${(this.props.transparent) ? style.transparent : ''} ${this.props.className || ''}`}
                    defaultValue={this.props.defaultValue}
                    value={this.props.value}
                    placeholder={this.props.placeholder || ''}
                    onChange={this.props.handleChange}
                    name={this.props.name || ''}
                    disabled={(this.props.disabled) ? 'disabled' : ''}
                    style={this.props.style || {}}
                    />
                    {
                        (this.props.error)
                        ? <span className={style['error-icon']}>&#9888;</span>
                        : ''
                    }
                    {
                        (this.props.error)
                        ? <span className={style.error}>{this.props.error}</span>
                        : ''
                    }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms/Forms/textarea.js